module.exports = __webpack_public_path__ + "img/arrow_left.3c3bc687.png";